import React from 'react';

const SpinnerComponent = () => {
  return (
    <div className="spinner-containerr">
    <div className="spinnerr"></div>
  </div>
    // <div style={{
    //     position: 'fixed',
    //     top: 0,
    //     left: 0,
    //     width: '100%',
    //     height: '100%',
    //     backgroundColor: 'rgba(255, 255, 255, 0.7)',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     zIndex: 9999,
    //   }}>
    //   <div  style={{
    //       border: '4px solid rgba(0, 0, 0, 0.1)',
    //       borderTop: '4px solid #3498db',
    //       borderRadius: '50%',
    //       width: '50px',
    //       height: '50px',
    //       animation: 'spin 1s linear infinite',
    //     }}></div>
    // </div>
  );
};

export default SpinnerComponent;
